const messageText = value => {
  if (typeof value === 'string') return value;
  if (Array.isArray(value)) return value.map(messageText).filter(Boolean).join(' ');
  if (value && typeof value === 'object') return messageText(value.message ?? value.messages);
  return '';
};

export const receiptPaymentValidation = error => {
  const payload = error?.response?.data;
  if (!payload || typeof payload !== 'object') return null;
  // Both the action endpoint and the common CRUD validation envelope occur here.
  const roots = [payload, payload.errors, payload.data, payload.data?.errors,
    payload.data?.data, payload.data?.data?.errors];
  for (const root of roots) {
    if (!root || typeof root !== 'object') continue;
    const amount = messageText(root.paidAmount ?? root.paid_amount ??
      root.fields?.paidAmount ?? root.fields?.paid_amount);
    if (amount) return {amount, general: ''};
    const violations = Array.isArray(root) ? root : root.violations;
    if (Array.isArray(violations)) {
      const messages = violations.filter(entry => ['paidAmount', 'paid_amount'].includes(entry?.propertyPath ?? entry?.field))
        .map(entry => messageText(entry.message)).filter(Boolean);
      if (messages.length) return {amount: messages.join(' '), general: ''};
    }
  }
  if ([400, 422].includes(error.response.status)) {
    const general = messageText(payload.message ?? payload.detail);
    if (general) return {amount: '', general};
  }
  return null;
};
